import React from "react";

export const LoginSuccess = ({ email }) => {
    return (
        <div className="text-center">
            <div className="flex items-center justify-center mb-4">
                <div className="bg-green-100 p-3 rounded-full">
                    <i className="fas fa-envelope-open-text text-green-600 text-2xl"></i>
                </div>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">¡Enlace Enviado!</h2>
            <p className="text-gray-700 mb-4">Te hemos enviado un enlace de acceso a:</p>
            <div className="bg-gray-50 p-3 rounded-lg border">
                <p className="font-semibold text-gray-800 break-all">{email}</p>
            </div>
            <div className="mt-4 p-3 bg-green-50 rounded-lg border border-green-200">
                <div className="flex items-start space-x-2">
                    <i className="fas fa-lightbulb text-green-600 mt-1 text-sm"></i>
                    <p className="text-sm text-green-800">
                        Revisa tu bandeja de entrada y haz clic en el enlace para continuar
                    </p>
                </div>
            </div>
        </div>
    );
};